"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TouchDetector =
/** @class */
function () {
  function TouchDetector(win, nav) {
    this.win = win;
    this.nav = nav; // Initial guess

    this._isTouch = 'ontouchstart' in this.win;
    this.externalListeners = new Map();
    this._onPointerMove = this._onPointerMove.bind(this);
    this.win.addEventListener('pointermove', this._onPointerMove);
  }

  Object.defineProperty(TouchDetector.prototype, "isTouch", {
    get: function get() {
      return this._isTouch;
    },
    set: function set(newValue) {
      if (this._isTouch === newValue) {
        return;
      }

      this._isTouch = newValue;
      var callback = this.externalListeners.get('change');
      callback && callback(this._isTouch);
    },
    enumerable: true,
    configurable: true
  });

  TouchDetector.prototype.destroy = function () {
    this.win.removeEventListener('pointermove', this._onPointerMove);
    this.externalListeners = new Map();
  };

  TouchDetector.prototype.addEventListener = function (eventName, callback) {
    this.externalListeners.set(eventName, callback);
  };

  TouchDetector.prototype.removeEventListener = function (eventName) {
    if (this.externalListeners.has(eventName)) {
      this.externalListeners.delete(eventName);
    }
  };

  TouchDetector.prototype._onPointerMove = function (e) {
    this.isTouch = e.pointerType === 'touch' || e.pointerType === 'pen';
  };

  return TouchDetector;
}();

exports.TouchDetector = TouchDetector;